import { useNavigate, useLocation, useParams } from 'react-router-dom';
import _ from 'lodash';
import { useContext } from 'react';
import { AppContext } from 'src/components/app/contexts/appContext';

function withUseHooks(Component) {
  
  function ComponentWithHooksProp(props) {
    
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const params = useParams();
    const navigate = useNavigate();
    const { smallTalk } = useContext(AppContext);
    const queryObj = {};

    queryParams.forEach((value, key) => {
      if (_.has(queryObj, key)) {
        queryObj[key] = _.castArray(queryObj[key]).concat(value);
      } else {
        queryObj[key] = value;
      }
    });

    const locationObj = {
      pathname: location.pathname,
      query: queryObj
    };

    return <Component {...props} navigate={navigate} params={params} location={locationObj} pathname={location.pathname} smallTalk={smallTalk} />;
  }
  return ComponentWithHooksProp;
}

export default withUseHooks;